<template>
  <div class="box-container">
    <d-header
      fluid
      :breadcrumbs="false"
      :actions="actions"
    >
      <h1 class="title">
        {{ $t('application_files') }}
      </h1>
    </d-header>

    <v-application-file-list
      :property="model"
    />
  </div>
</template>

<script>

import list from "./_list.vue";
import { i18n } from "@/services/i18n";

export default {
  metaInfo() {
    return {
      title: this.$t("application_files").capitalize()
    };
  },
  components: {
    "v-application-file-list": list
  },
  props: {
    model: {
      default: null,
      type: Object,
    },
  },
  computed: {
    actions(){
      if (window.Laravel.user.role !== "admin") {
        return [];
      }

      return [
        {
          label: i18n.t("new_application_file"),
          path: "/properties/"+this.model.id+"/application-files/create",
          primary: true,
          color: "is-primary",
          resource: "applicationFile",
        }
      ];
    }
  },
};
</script>
